import type { ProviderDeepLinkModel } from './providerDeepLink'

export type OrderItemOption = {
  id: number,
  title?: string,
  value: {
    id: number,
    title?: string,
    price?: number,
  },
}

export type CreateOrderItemPayload = {
  order_id: number,
  data?: any,
  favourite_order_id?: number,
  item_type: 'orderable',
  options?: OrderItemOption[] | string,
  package_id?: number,
  price_list_item_id?: number,
  title: string,
}

export type OrderItemModel = {
  additional_instructions?: string,
  agency_id?: number,
  agent_ids?: number[],
  artwork_id?: number,
  base_price: number,
  cache_key: number,
  campaign_id?: number,
  campaign_proposal_id?: number,
  data?: any,
  dates?: {
    due?: {
      date?: string,
    },
    updated?: {
      date_time?: string,
    },
  },
  deep_link?: ProviderDeepLinkModel,
  deep_link_url?: string,
  id: number,
  last_completed_task_id?: number,
  options_string?: string,
  options?: OrderItemOption[],
  order_id: number,
  price_inc_fee?: number,
  price?: number,
  priority_campaign_user_ids?: number[],
  processing_fee?: number,
  provider_id?: number,
  provider_price_list_id?: number,
  provider_price_list_item_id?: number,
  publication_edition_id?: number,
  publication_id?: number,
  quantity?: number,
  service_id?: number,
  service_product_id?: number,
  status_id: number,
  title: string,
  type?: 'OrderItem',
}

export type OrderItemRequestOptions = {
  include_order_item_priority_campaign_user_ids?: boolean,
}

const state = {
  additional_instructions: '',
  status_id: undefined,
}

export const requiredFields = []

export default state
